import { defineMessages } from 'react-intl';

export default defineMessages({
  logoutTitle: {
    id: 'logout.title',
    defaultMessage: 'Log out of your Atlassian account',
    description: 'Page title and heading for the logout page when the user has a single session.',
  },
  logoutTitleMultiple: {
    id: 'logout.title.multiple',
    defaultMessage: 'Log out of your Atlassian accounts',
    description: 'Heading for the logout page when the user has multiple sessions.',
  },
  switchAccount: {
    id: 'logout.switch-account',
    defaultMessage: 'Log in to another account',
    description: 'Link text to navigate to the account selection page instead of logging out.',
  },
  logoutConfirm: {
    id: 'logout.confirm',
    defaultMessage: 'Log out',
    description: 'Button text to confirm logging out of a single session.',
  },
  logoutConfirmMultiple: {
    id: 'logout.confirm.multiple',
    defaultMessage: 'Log out of all accounts',
    description: 'Button text to confirm logging out of all sessions.',
  },
  logoutRequiredError: {
    id: 'logout.error.logout_required',
    defaultMessage: 'To continue with this account, log out and sign in again.',
    description:
      'Error shown when a user must log out and re-authenticate before they can continue to their destination.',
  },
  logoutFormError: {
    id: 'logout.error.form_error',
    defaultMessage: 'Something went wrong. Please try again.',
    description:
      'Generic error shown when the logout form submission fails, such as due to a CSRF token issue. The user can try to resubmit.',
  },
});
